export const convertStringFromCamelCaseToKebabCase = (camelCaseString: string): string => {
  return camelCaseString.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
};
